/*
 * mega-menu-rp.js
 * Comportement du mega-menu (snippets/header-mega-menu.liquid).
 *
 * Deux choses :
 * 1. ouverture au SURVOL de l'onglet (Dawn n'ouvre qu'au clic), avec une
 *    petite temporisation a la sortie pour laisser traverser le vide entre
 *    l'onglet et le panneau ;
 * 2. la colonne des sous-liens suit la rubrique survolee ; a l'ouverture
 *    aucune rubrique n'est depliee d'office, la colonne reste vide.
 *
 * Delegation sur le document : les sections de l'editeur de theme sont
 * rechargees a chaque modification, et aucun ecouteur pose sur leur contenu
 * ne survivrait. Le clic reste geré par <details> : sans JavaScript, ou au
 * clavier, le menu s'ouvre et se ferme normalement.
 */
(() => {
  const MEGA = 'details.mega-rp';
  const BUREAU = '(min-width: 990px)';
  const DELAI_FERMETURE = 180;

  let minuteur = null;

  function surBureau() {
    return window.matchMedia(BUREAU).matches;
  }

  function sousMenus(details) {
    return Array.from(details.querySelectorAll('[data-sous-menu-cible]'));
  }

  function afficherSousMenu(details, cle) {
    const listes = sousMenus(details);
    if (listes.length === 0) return;

    const choisi = cle ? listes.find((liste) => liste.dataset.sousMenuCible === cle) : null;
    listes.forEach((liste) => {
      liste.hidden = liste !== choisi;
    });

    details.querySelectorAll('[data-sous-menu]').forEach((rubrique) => {
      rubrique.classList.toggle('is-active', !!choisi && rubrique.dataset.sousMenu === choisi.dataset.sousMenuCible);
    });
  }

  function ouvrir(details) {
    clearTimeout(minuteur);
    if (details.hasAttribute('open')) return;

    // Une seule rubrique ouverte a la fois, comme au clic.
    document.querySelectorAll(`${MEGA}[open]`).forEach((autre) => {
      if (autre !== details) fermer(autre);
    });

    details.setAttribute('open', '');
    details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    afficherSousMenu(details, null);
  }

  function fermer(details) {
    details.removeAttribute('open');
    details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('mouseover', (evt) => {
    if (!surBureau()) return;
    const cible = evt.target instanceof Element ? evt.target : null;
    if (!cible) return;

    const details = cible.closest(MEGA);
    if (!details) return;

    ouvrir(details);

    // Une rubrique SANS sous-liens (ex. « Par Artistes ») vide la colonne : sinon les
    // sous-liens de la rubrique survolee precedemment restaient affiches.
    const lien = cible.closest('.mega-rp__rubrique');
    if (lien) afficherSousMenu(details, lien.dataset.sousMenu || null);
  });

  document.addEventListener('mouseout', (evt) => {
    if (!surBureau()) return;
    const cible = evt.target instanceof Element ? evt.target : null;
    const details = cible ? cible.closest(MEGA) : null;
    if (!details) return;

    // relatedTarget nul = souris sortie de la fenetre.
    const vers = evt.relatedTarget instanceof Element ? evt.relatedTarget : null;
    if (vers && details.contains(vers)) return;

    clearTimeout(minuteur);
    minuteur = setTimeout(() => fermer(details), DELAI_FERMETURE);
  });

  /* Clavier : le focus qui entre dans une rubrique montre ses sous-liens,
     et Echap referme le panneau ouvert. */
  document.addEventListener('focusin', (evt) => {
    const cible = evt.target instanceof Element ? evt.target : null;
    const details = cible ? cible.closest(MEGA) : null;
    if (!details) return;
    if (details.hasAttribute('open')) {
      const lien = cible.closest('.mega-rp__rubrique');
      if (lien) afficherSousMenu(details, lien.dataset.sousMenu || null);
    }
  });

  document.addEventListener('keydown', (evt) => {
    if (evt.key !== 'Escape') return;
    const ouvert = document.querySelector(`${MEGA}[open]`);
    if (!ouvert) return;
    fermer(ouvert);
    ouvert.querySelector('summary')?.focus();
  });

  /* Etat initial des panneaux ouverts au clic (sans survol). */
  document.addEventListener('toggle', (evt) => {
    const details = evt.target instanceof Element ? evt.target.closest(MEGA) : null;
    if (details && details.hasAttribute('open')) afficherSousMenu(details, null);
  }, true);
})();
